export default {
  name: 'dashboard',
  translationKey: 'dashboard-module',
  routePrefix: 'dashboard',
  routeNamePrefix: 'dashboard',
}
